export default "__VITE_ASSET__Fc4VaVx1__"